import { defineStore } from 'pinia';
import { ref } from 'vue';
import SalesTeamsAPI from 'dashboard/api/salesTeams';

export const useSalesTeamsStore = defineStore('salesTeams', () => {
  const teams = ref([]);
  const isFetching = ref(false);
  const isSaving = ref(false);

  async function fetch() {
    isFetching.value = true;
    try {
      const { data } = await SalesTeamsAPI.get();
      teams.value = data.teams ?? [];
    } finally {
      isFetching.value = false;
    }
  }

  async function setManager(teamId, managerId) {
    isSaving.value = true;
    try {
      const { data } = await SalesTeamsAPI.update(teamId, managerId);
      const team = teams.value.find(t => t.id === teamId);
      if (team) {
        team.manager_id = data.manager_id;
        team.manager_name = data.manager_name;
      }
    } finally {
      isSaving.value = false;
    }
  }

  return { teams, isFetching, isSaving, fetch, setManager };
});
